export default __webpack_public_path__ + "static/media/sounds/maze_practice_incorrect_answer_selected_alyx.mp3";